import { useEffect } from "react";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";

import PrimaryView from "./views/primary/PrimaryView";
import OfficesView from "./views/offices/OfficesView";
import EmployeesView from "./views/employees/EmployeesView";
import VendorsView from "./views/vendors/VendorsView";
import CustomersView from "./views/customers/CustomersView";

import FeatureErrorBoundary from "../../atoms/FeatureErrorBoundary";
import PageTabs from "../../atoms/PageTabs";

import useEmissionsContext from "../../../helpers/contexts/emissions";
import { analyticsPage } from "../../../helpers/analytics";
import usePlatformLayoutContext from "../../../helpers/contexts/platformLayout";

const tabs = [
  { value: "primary", label: "Primary" },
  { value: "offices", label: "Offices" },
  { value: "employees", label: "Employees" },
  { value: "vendors", label: "Vendors" },
  { value: "customers", label: "Customers" }
];

const DashboardBlock = () => {
  const history = useHistory();
  const { view } = useParams();
  const { rootPath } = usePlatformLayoutContext();
  const { emissionsLoading, allEmissions } = useEmissionsContext();

  const selectedDashboard = view || "primary";

  useEffect(() => {
    analyticsPage("dashboard");
  }, []);

  const dashboardViews = {
    primary: (
      <PrimaryView allEmissions={allEmissions} viewLoading={emissionsLoading} />
    ),
    offices: <OfficesView viewLoading={emissionsLoading} />,
    employees: <EmployeesView viewLoading={emissionsLoading} />,
    vendors: <VendorsView viewLoading={emissionsLoading} />,
    customers: <CustomersView />
  };

  return (
    <FeatureErrorBoundary featureName="Dashboard">
      <PageTabs
        tabs={tabs}
        value={selectedDashboard}
        onChange={(_, v) =>
          history.push(`${rootPath}/dashboard${v === "primary" ? "" : `/${v}`}`)
        }
      />
      {dashboardViews[selectedDashboard]}
    </FeatureErrorBoundary>
  );
};
export default DashboardBlock;
